const scriptURL = 'https://accounts.google.com/gsi/client'
let loader

export function loadGoogleIdentityServices () {
  if (window.google?.accounts?.id) {
    return Promise.resolve(window.google.accounts.id)
  }
  if (loader) {
    return loader
  }

  loader = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${scriptURL}"]`)
    const script = existing || document.createElement('script')
    script.addEventListener('load', () => resolve(window.google.accounts.id), { once: true })
    script.addEventListener('error', () => {
      loader = undefined
      script.remove()
      reject(new Error('Unable to load Google Sign-In.'))
    }, { once: true })
    if (!existing) {
      script.src = scriptURL
      script.async = true
      script.defer = true
      document.head.appendChild(script)
    }
  })

  return loader
}

export async function renderGoogleButton ({ element, clientId, callback }) {
  const googleIdentity = await loadGoogleIdentityServices()
  googleIdentity.initialize({ client_id: clientId, callback })
  googleIdentity.renderButton(element, {
    type: 'standard',
    theme: 'outline',
    size: 'large',
    text: 'signin_with',
    shape: 'rectangular',
    width: 320
  })
}

export function disableGoogleAutoSelect () {
  window.google?.accounts?.id?.disableAutoSelect()
}
